import { Flex, Tooltip } from 'antd';
import React from 'react';
import { Typography } from 'tfc-components';

import Icon, { IconName } from 'components/atoms/Icon';

interface FormFieldProps {
  label: string;
  subLabel?: string;
  icon?: IconName;
  children: React.ReactNode;
  style?: React.CSSProperties;
  required?: boolean;
  tooltipContent?: string;
  type?: 'label' | 'subLabel';
  tooltipWidth?: number
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  icon,
  children,
  style,
  required,
  tooltipContent,
  type = 'label',
  tooltipWidth,
  subLabel,
  tooltipPlacement = 'top',
}) => (
  <div className="o-formField" style={style}>
    <div className="o-formField-label">
      <Flex vertical gap={6}>
        <Typography.Text fontweight={type === 'label' ? '600' : '400'} extendClasses="o-formField-labelText">
          {required && (
            <Typography.Text type="span" extendClasses="o-formField-required">
              {' '}
              *
            </Typography.Text>
          )}
          {label}
        </Typography.Text>
        {subLabel && <Typography.Text extendClasses="fs-14x18 o-formField_subLabel">{subLabel}</Typography.Text>}
      </Flex>
      {icon && (
        <Tooltip
          placement={tooltipPlacement}
          key={tooltipContent}
          overlayInnerStyle={{ width: tooltipWidth || 'fit-content', }}
          title={<Typography.Text>{tooltipContent ?? label}</Typography.Text>}
        >
          <span>
            <Icon iconName={icon} size="20" />
          </span>
        </Tooltip>
      )}
    </div>
    {children}
  </div>
);

export default FormField;
